import { render, staticRenderFns } from "./articlemanagevenueedit.vue?vue&type=template&id=33de765f&scoped=true&"
import script from "./articlemanagevenueedit.vue?vue&type=script&lang=js&"
export * from "./articlemanagevenueedit.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagevenueedit.vue?vue&type=style&index=0&id=33de765f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de765f",
  null
  
)

component.options.__file = "articlemanagevenueedit.vue"
export default component.exports